import NodeModel from '../NodeModel';
import NodeWidget from '../NodeWidget';

import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

export default class NodeFactory extends AbstractReactFactory {
  constructor() {
    super("NG_INSIGHT_DIAGRAM_NODE");
  }

  generateReactWidget = e => (
    <NodeWidget
        engine={this.engine} 
        node={e.model}
    />
  )

  generateModel = () => new NodeModel();
}